import * as ambassadorWixEcomCustomTriggerV1CustomTrigger from './ecom-custom-trigger-v1-custom-trigger-discounts-custom-trigger.http.js';
import * as ambassadorWixEcomCustomTriggerV1CustomTriggerTypes from './ecom-custom-trigger-v1-custom-trigger-discounts-custom-trigger.types.js';
import * as ambassadorWixEcomCustomTriggerV1CustomTriggerUniversalTypes from './ecom-custom-trigger-v1-custom-trigger-discounts-custom-trigger.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listTriggers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomCustomTriggerV1CustomTriggerUniversalTypes.ListTriggersRequest,
  ambassadorWixEcomCustomTriggerV1CustomTriggerTypes.ListTriggersRequest,
  ambassadorWixEcomCustomTriggerV1CustomTriggerUniversalTypes.ListTriggersResponse,
  ambassadorWixEcomCustomTriggerV1CustomTriggerTypes.ListTriggersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomCustomTriggerV1CustomTrigger.listTriggers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/discount-custom-triggers/list',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CustomTrigger as CustomTriggerOriginal,
  GetEligibleTriggersRequest as GetEligibleTriggersRequestOriginal,
  LineItem as LineItemOriginal,
  CatalogReference as CatalogReferenceOriginal,
  TriggerToFilterBy as TriggerToFilterByOriginal,
  ShippingInfo as ShippingInfoOriginal,
  Address as AddressOriginal,
  GetEligibleTriggersResponse as GetEligibleTriggersResponseOriginal,
  EligibleTrigger as EligibleTriggerOriginal,
  ListTriggersRequest as ListTriggersRequestOriginal,
  ListTriggersResponse as ListTriggersResponseOriginal,
  ListTriggersResponseCustomTrigger as ListTriggersResponseCustomTriggerOriginal,
} from './ecom-custom-trigger-v1-custom-trigger-discounts-custom-trigger.types.js';
